import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';
import type { IInvoiceObject } from '@/common/interfaces/invoice.interface';
import { removeDuplicates } from '@/utilities/CommonUtils';

interface IInvoiceSectionResp {
  invoices: IInvoiceObject[];
  count: number;
}

/** Defining a service using a base URL and expected endpoints  */
export const invoiceQuery = createApi({
  reducerPath: 'invoiceQuery',
  tagTypes: ['Invoice'],
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getInvoices: builder.query({
      query: ({ limit, page }) => ({
        url: `api/cp/invoice?limit=${limit}&page=${page}`,
        method: 'get',
      }),
      transformResponse: (response: IInvoiceSectionResp) => ({
        invoices: response.invoices,
        count: response.count,
      }),
      /** Only have one cache entry because the arg always maps to one string */
      serializeQueryArgs: ({ endpointName }) => endpointName,
      /** Always merge incoming data to the cache entry */
      merge: (currentCache, newItems) => {
        currentCache.invoices.push(...newItems.invoices);
        currentCache.invoices = removeDuplicates(currentCache.invoices, 'invoiceId');
      },
      /** Refetch when the page arg changes */
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),
  }),
});

/** Export hooks for usage in functional components, which are auto-generated based on the defined endpoints */
export const { useGetInvoicesQuery } = invoiceQuery;
